import React from 'react'
import { fileUrl, urlFor } from '../lib/client';
import CustomerLogo from './CustomerLogo';

const PrivacyPolicy = ({customer}) => {

    //console.log("customer w.elkfmwldfmwledfmew", customer)
    const customerAddress = () => {
        return (
            <div>
                {customer?.name && <p>{customer?.name}</p>}
                
                {customer?.address1 && <p>{customer?.address1}, {customer?.houseNumber ? customer?.houseNumber + ", " : "" }</p>}
                {customer?.address2 && <p>{customer?.address2}</p>}
                {customer?.postCode && <p>{customer?.postCode}</p>}  
                {customer?.city && <p>{customer?.city},  {customer?.province ? customer?.province  : ""}</p>}
                

            </div>
            
        )
    }

  return ( 

  <div>
    <div style={{marginBottom: "30px", display: "flex", justifyContent: "center"}}>
        <img style={{width: `${customer?.logoHeaderSize?.width}px`, height: `${customer?.logoHeaderSize?.height}px`}} src = {customer?.logoHeader && urlFor(customer?.logoHeader)?.url()} alt="logo"/> 
    </div> 
    <h2 style={{marginBottom: "30px"}}>INFORMATIVA AI SENSI DELL’ART. 13 DEL REGOLAMENTO UE 2016/679 (GDPR)</h2>

    <h3>1. Tipologia di dati trattati</h3>
    <p>Il Titolare tratta le seguenti categorie di dati:</p>
    <ul>
      <li>Dati anagrafici e identificativi: nome, cognome, ente/azienda, ruolo, recapiti telefonici e email;</li>
      <li>Dati societari: ragione sociale, sede legale, partita IVA, codice fiscale, PEC, riferimenti contrattuali;</li>
      <li>
        Dati tecnici relativi ai dispositivi oggetto di manutenzione: matricole, ubicazioni, date di installazione,
        scadenze manutentive, esiti degli interventi;
      </li>
      <li>Eventuali dati di contatto personali del referente interno alla struttura pubblica o privata.</li>
    </ul>

    <h3>2. Finalità del trattamento</h3>
    <p>I dati personali sono trattati per le seguenti finalità:</p>
    <ul>
      <li>Gestione del rapporto contrattuale;</li>
      <li>Pianificazione ed esecuzione delle attività di manutenzione preventiva e correttiva dei dispositivi antincendio;</li>
      <li>Gestione delle comunicazioni con il cliente (email, telefono, PEC);</li>
      <li>Conservazione della documentazione tecnica e manutentiva;</li>
      <li>Adempimento degli obblighi previsti da leggi e regolamenti;</li>
      <li>Eventuali finalità di tutela legale in caso di controversie.</li>
    </ul>

    <h3>3. Base giuridica del trattamento</h3>
    <p>Il trattamento è lecito in quanto:</p>
    <ul>
      <li>Necessario all’esecuzione di un contratto (art. 6, par. 1, lett. b, GDPR);</li>
      <li>Necessario per adempiere a obblighi legali (art. 6, par. 1, lett. c, GDPR);</li>
      <li>Basato sul legittimo interesse del Titolare (art. 6, par. 1, lett. f, GDPR).</li>
    </ul>

    <h3>4. Modalità di trattamento e conservazione</h3>
    <p>
      Il trattamento avverrà mediante strumenti cartacei e/o informatici, nel rispetto delle misure di sicurezza
      previste. I dati saranno conservati per tutta la durata del contratto e per il tempo necessario a rispettare
      obblighi di legge.
    </p>

    <h3>5. Comunicazione e diffusione dei dati</h3>
    <p>I dati non saranno oggetto di diffusione. Potranno essere comunicati a:</p>
    <ul>
      <li>Personale autorizzato interno;</li>
      <li>Fornitori di servizi informatici e manutentivi;</li>
      <li>Enti pubblici o autorità nei casi previsti dalla legge.</li>
    </ul>

    <h3>6. Diritti dell’interessato</h3>
    <p>
      L’interessato può esercitare i diritti di accesso, rettifica, cancellazione, limitazione, opposizione, portabilità
      dei dati e presentare reclamo al Garante (
      <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a>).
    </p>
    <p>Richieste vanno inviate a:</p>
    <ul>
      <li>Email: {customer?.email}</li>
      <li>PEC: {customer?.pec}</li>
    </ul>

    <h3>7. Titolare del trattamento</h3>
    <p>
      Il Titolare è: {customer?.name}, con sede in [Indirizzo completo], contattabile ai seguenti
      recapiti:
    </p>
    {customerAddress()}
    <ul>
      <li>Email: {customer?.email}</li>
      <li>Telefono: {customer?.phoneNumber}</li>
    </ul>

    <h3>8. Obbligatorietà del conferimento dei dati</h3>
    <p>
      Il conferimento dei dati è necessario per la gestione del rapporto contrattuale. Il mancato conferimento comporta
      l’impossibilità di erogare il servizio.
    </p>
  </div>
);
}

export default PrivacyPolicy
